<template>
    <div />
</template>

<script>

export default {
    async mounted() {
        this.$nextTick(_ => {
            this.$store.commit('auth/DESTROY_TOKENS')
            this.$router.push({ name: 'login' })
        })
    }
}
</script>
